/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationStateForResult } from './EvaluationStateForResult';
import {
    instanceOfEvaluationStateForResult,
    EvaluationStateForResultFromJSON,
    EvaluationStateForResultFromJSONTyped,
    EvaluationStateForResultToJSON,
} from './EvaluationStateForResult';

/**
 * @type BeamConstancyWorkResultDtoOutput
 * 
 * @export
 */
export type BeamConstancyWorkResultDtoOutput = EvaluationStateForResult;


export function BeamConstancyWorkResultDtoOutputFromJSON(json: any): BeamConstancyWorkResultDtoOutput {
    return BeamConstancyWorkResultDtoOutputFromJSONTyped(json, false);
}

export function BeamConstancyWorkResultDtoOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkResultDtoOutput {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationStateForResultFromJSONTyped(json, true) };
    return  EvaluationStateForResultFromJSONTyped(json, true);
}

export function BeamConstancyWorkResultDtoOutputToJSON(value?: BeamConstancyWorkResultDtoOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationStateForResult(value)) {
        return EvaluationStateForResultToJSON(value as EvaluationStateForResult);
    }

    return {};
}

/**
 * Check if a given object implements the BeamConstancyWorkResultDtoOutput interface.
 */
export function instanceOfBeamConstancyWorkResultDtoOutput(value: any): value is BeamConstancyWorkResultDtoOutput {
    if (instanceOfEvaluationStateForResult(value)) return true;
    return false;
}

